export default __webpack_public_path__ + "static/media/speakerdeck.ae4a8b8a.svg";